export default function hasNumbers(value) {
  return typeof value === 'string' && /[0-9]/.test(value)
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/hasNumbers.js